<script setup lang="ts">
import { generateReturnURLs } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-vue-next';
import { useToast } from '@/components/ui/toast/use-toast';
import axios from 'axios';
import { inject, Ref, ref } from 'vue';
import { useRoute } from 'vue-router';

const payLoader = ref(false);
const { toast } = useToast();
const route = useRoute();

const patientId = inject('manage_appointment:patient_id') as Ref<string>;

function pay() {
  if (!payLoader.value) {
    payLoader.value = true;
    console.log(patientId);
    const values = generateReturnURLs(route.query.appID as string, { ...route, params: { ...route.params, patientId: patientId.value } });
  
    axios.post('/checkout', values).then((res: any) => {
      if (res.status == 'success') {
        window.location.href = res.data.url
      } else {
        toast({
          title: res.msg,
          variant: 'destructive'
        });
      }
    }).catch(() => {
      toast({
        title: 'An error occurred while checking out. Please try again.',
        variant: 'destructive'
      });
    }).finally(() => {
      payLoader.value = false;
    });
  }
}
</script>

<template>
  <Button size="lg" @click="pay" variant="default" class="!text-lg mt-4 font-semibold w-full flex items-center justify-center">
    <Loader2 v-if="payLoader" class="size-5 mr-3 animate-spin" />
    <span v-else>Pay</span>
  </Button>
</template>